// Mirrors --colors-purple-* CSS variables from src/assets/palete.scss
const PURPLE = {
  25: "#F6F2FF",
  50: "#EDE5FF",
  100: "#E8DAFF",
  200: "#D4BBFF",
  500: "#8A3FFC",
  600: "#6929C4",
  700: "#491D8B",
};

// Mirrors --colors-secondary-* CSS variables from src/assets/palete.scss
const SECONDARY = {
  25: "#F6F9FE",
  50: "#E3F2FD",
  100: "#BBDEFB",
  200: "#90CAF9",
  300: "#64B5F6",
  400: "#42A5F5",
  500: "#2196F3",
  600: "#1E88E5",
  700: "#1976D2",
  800: "#1565C0",
};

// Most vivid first → the segment with the most students gets the strongest color
export const SCORE_COLOR_LIST = [
  PURPLE[500],
  PURPLE[700],
  PURPLE[600],
  PURPLE[200],
  PURPLE[100],
  PURPLE[50],
  PURPLE[25],
  SECONDARY[500],
  SECONDARY[700],
  SECONDARY[800],
  SECONDARY[600],
  SECONDARY[400],
  SECONDARY[300],
  SECONDARY[200],
  SECONDARY[100],
  SECONDARY[50],
  SECONDARY[25],
];
